import { AuthProviderProps } from "react-oidc-context";

const oidcConfig: AuthProviderProps = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}`,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string,
  redirect_uri:
    window.location.origin + "/" + process.env.REACT_APP_KEYCLOAK_OKTA_IDP,
  post_logout_redirect_uri:
    window.location.origin + "/" + process.env.REACT_APP_KEYCLOAK_OKTA_IDP,
  onSigninCallback: () => {
    // Remove OIDC params from URL after successful signin
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export default oidcConfig;
